import { get, forEach, find, size } from 'lodash-es';
import * as Yup from 'yup';
import { checkIsNull } from '../../Utils/utils';
import { checkConditionsByValues } from '../../Utils/utils';
import { TypesFieldEnum } from './QuotationBlock.enum';

/**
 * get validation shema
 * @param code
 * @param validation
 * @returns {*|Requireable<InferProps<P>>}
 */
const getValidationSchema = ({ code, type, validation, values }) => {
  try {
    const yupSchema = {};
    let customYup;

    switch (type) {
      case TypesFieldEnum.NUMBER:
        if (!checkIsNull(find(validation, validationItem => !checkIsNull(get(validationItem, 'matches'))))) {
          // eslint-disable-next-line no-console
          console.error(`getValidationSchema: type Number cannot contain RegEx validation`);
          return;
        }

        customYup = Yup.number();
        break;
      case TypesFieldEnum.DATE:
      case TypesFieldEnum.BIRTH_DATE:
        if (!checkIsNull(find(validation, validationItem => !checkIsNull(get(validationItem, 'matches'))))) {
          // eslint-disable-next-line no-console
          console.error(`getValidationSchema: type Date cannot contain RegEx validation`);
          return;
        }

        customYup = Yup.date();
        break;
      default: {
        customYup = Yup.string();
      }
    }

    forEach(validation, validationItem => {
      const conditions = get(validationItem, 'conditions', []);
      let activateValidation = true;

      if (size(conditions) > 0) {
        activateValidation = checkConditionsByValues({ conditions, values });
      }
      //
      if (activateValidation) {
        // required
        if (!checkIsNull(get(validationItem, 'required'))) {
          customYup = customYup.required(get(validationItem, 'message'));
        }
        // min
        if (!checkIsNull(get(validationItem, 'min'))) {
          customYup = customYup.min(get(validationItem, 'min'), get(validationItem, 'message'));
        }
        // max
        if (!checkIsNull(get(validationItem, 'max'))) {
          customYup = customYup.max(get(validationItem, 'max'), get(validationItem, 'message'));
        }
        // matches
        if (!checkIsNull(get(validationItem, 'matches'))) {
          // RegExp add => /${reg}/ => regExp generator => https://regexr.com/
          customYup = customYup.matches(new RegExp(get(validationItem, 'matches')), get(validationItem, 'message'));
        }
      }

      yupSchema[code] = customYup;
    });

    return Yup.object().shape(yupSchema);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`getValidationSchema: ${e.stack}`);
  }
  return undefined;
};

/**
 * validate
 * @param code
 * @param validationSchema
 */
export const validate =
  ({ code, type, validation, values }) =>
  value => {
    try {
      let validationSchema;
      // get validation schema
      if (size(validation) > 0) {
        validationSchema = getValidationSchema({
          code,
          type,
          validation,
          values,
        });
      }
      // validate
      if (!checkIsNull(validationSchema)) {
        return validationSchema
          .validate({ [code]: value })
          .then(() => {})
          .catch(validationError => get(validationError, `errors[0]`));
      }

      return '';
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`validate: ${e.stack}`);
    }
    return undefined;
  };
